import styled from "styled-components";

export const Text = styled.text`
  fill: var(--section-slate-fill, var(--slate));
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;
